import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EAuthStatus } from 'services/auth';
import { IAuthStore, ILoginRequestPayload, IMerchantIdPayload, TSavedUrl } from './types';

// ==========================================:
export const initialState: IAuthStore = {
	status: EAuthStatus.Unknown,
	isAuthenticated: false,
	loginLoader: false,
	xMerchantId: null,
	savedUrl: null,
	savedUrl2: null,
	savedUrl3: null,
	realmRoles: [],
};

// ==========================================:
const auth = createSlice({
	name: '@@auth',
	initialState,
	reducers: {
		authStatusChanged: (state: IAuthStore, action: PayloadAction<EAuthStatus>) => {
			const { payload } = action;
			const authState = state;
			authState.status = payload;
			authState.isAuthenticated = payload === EAuthStatus.Authenticated;
		},

		accountLoginRequest: (state: IAuthStore, _action: PayloadAction<ILoginRequestPayload>) => {
			const accountLoginState = state;
			accountLoginState.loginLoader = true;
		},
		accountLoginFinished: (state: IAuthStore) => {
			const accountLoginState = state;
			accountLoginState.loginLoader = false;
		},

		logoutRequest: () => {},

		getMerchantIdSuccess: (state: IAuthStore, action: PayloadAction<IMerchantIdPayload>) => {
			const { payload } = action;
			const merchantIdState = state;
			merchantIdState.xMerchantId = payload?.xMerchantId ?? null;
		},

		saveUrl: (state: IAuthStore, action: PayloadAction<TSavedUrl>) => {
			const saveUrlState = state;
			saveUrlState.savedUrl = action.payload;
		},
		saveUrl2: (state: IAuthStore, action: PayloadAction<TSavedUrl>) => {
			const saveUrlState = state;
			saveUrlState.savedUrl2 = action.payload;
		},
		saveUrl3: (state: IAuthStore, action: PayloadAction<TSavedUrl>) => {
			const saveUrlState = state;
			saveUrlState.savedUrl3 = action.payload;
		},

		setRealmRoles: (state: IAuthStore, action: PayloadAction<string[]>) => {
			const realmRolesState = state;
			const current = realmRolesState.realmRoles ?? [];
			const next = action.payload ?? [];
			// Leave the slice untouched when nothing changed: a change before REHYDRATE would make
			// redux-persist skip restoring the persisted auth keys (autoMergeLevel1).
			if (current.length === next.length && current.every((role, i) => role === next[i])) return;
			realmRolesState.realmRoles = next;
		},
	},
});

export default auth.reducer;
export const {
	authStatusChanged,
	accountLoginRequest,
	accountLoginFinished,
	logoutRequest,
	getMerchantIdSuccess,
	saveUrl,
	saveUrl2,
	saveUrl3,
	setRealmRoles,
} = auth.actions;
